import { CreateWithHoldingTaxRateDto } from "./../../../dtos/catalogs/withholdingtaxrate/CreateWithHoldingTaxRateDto";
import React from "react";
import { WithHoldingTaxRateDetail } from "../../../components/Pages/Catalogs/WithHoldingTaxRate/WithHoldingTaxRateDetail";
import { WithHoldingTaxRateService } from "../../../services/catalogs/WIthHoldingTaxRateService";
import { IAppEntity } from "../../entities";
import { ReferenceTypes } from "../../../enums/ReferenceTypes";
import { NFLookupWithHoldingTaxRate } from "../../../components/Shared/NewForms/NFLookupWithHoldingTaxRate";
import WithHoldingTaxRateList from "../../../components/Pages/Catalogs/WithHoldingTaxRate/WithHoldingTaxRateList";

export const WithHoldingTaxRate: IAppEntity = {
  entityType: "catalog",
  title: "WithHoldingTaxRate",
  pluralTitle: "WithHoldingTaxRate",
  apiUrl: "WithHoldingTaxRates",
  apiEnum: ReferenceTypes.CatalogWarehouse,
  getDetailViewComponent(
    model: any,
    modelUpdatedEvent: (model: any) => void
  ): any {
    return React.createElement(WithHoldingTaxRateDetail, {
      model: model,
      modelUpdatedEvent: modelUpdatedEvent,
    });
  },
  getListView: (model: any, modelUpdatedEvent: (model: any) => void) =>
    React.createElement(WithHoldingTaxRateList, {
      model: model,
      modelUpdatedEvent: modelUpdatedEvent,
    }),
  getLookupComponent(model: any): any {
    return React.createElement(NFLookupWithHoldingTaxRate, {
      fieldName: model.fieldName,
      title: model.title,
      setSelectedCatalog: model.setSelectedCatalog,
    });
  },
  getDataService() {
    return new WithHoldingTaxRateService(this.apiUrl);
  },
  getEmptyModel(): CreateWithHoldingTaxRateDto {
    return {
      name: "",
      description: "",
      paymentType: 0,
      rate: 0,
    };
  },
};
